export const vaccineAgeRestrictions = (age, products) => {
  // Filter vaccines based on the provided age
  const eligibleVaccines = products?.filter((vaccine) => {
    return age >= vaccine.Min_Age__c && (age <= vaccine.Max_Age__c || !vaccine.Max_Age__c);
  });
  return eligibleVaccines;
};
